/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCalendarTime/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaCalendarTime({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarTime",
  onClick,
  selected,
  isNative,
  value
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type={isNative ? "secondary" : "ghost"}
 size="small"
 block={true}
 onClick={onClick}
 selected={selected}
 marginBottom={isNative ? dtSpaceS : "0px"}
 marginRight={0}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={value}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}